/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type SectionItem = typeof SectionItem[keyof typeof SectionItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SectionItem = {
  'business-and-industry': 'business-and-industry',
  environment: 'environment',
  'health-and-public-welfare': 'health-and-public-welfare',
  money: 'money',
  'science-and-technology': 'science-and-technology',
  world: 'world',
} as const;
